import React, { useEffect, useState } from "react";
import { IMedia, LayoutCommonProps } from "../../../types";
import LayoutModal from "../../media-card/FullScreenModal";
import { LayoutHeader } from "../LayoutHeader";
import RatingToast from "../RatingToast";
import { Collection } from "@aws-amplify/ui-react";
import { MediaCard } from "../../media-card";

export const Layout1: React.FC<LayoutCommonProps> = ({
    mediaItems,
    mediaRating,
    onWatchClick,
    onRatingSuccess,
    isSignedIn,
    sessionToken,
    activePlans,
    hasFullAccess,
    freeTrialPlanIds,
    playlistTitle,
    enableCompetitionMode,
    refreshMediaRatings,
    enableRatingControls,
    mediaPerPage
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [mainMedia, setMainMedia] = useState<IMedia | undefined>(undefined);
    const [showToast, setShowToast] = useState(false);

    const handleRatingSuccessLocal = () => {
        setShowToast(true);
        onRatingSuccess();
        refreshMediaRatings?.()
    };

    useEffect(() => {
        if (mediaItems.length && !mainMedia) {
            const firstMedia = mediaItems[0];
            setMainMedia(firstMedia);
        }
    }, [mediaItems, mainMedia]);


    const handleSeeAllClick = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const onCardClick = (item: IMedia) => {
        setMainMedia(item);
    };

    if (!mediaItems.length || !mainMedia) return null;

    const remainingMedia = mediaItems;

    return (
        <>
            <LayoutHeader
                title={playlistTitle}
                itemCount={mediaItems?.length}
                onSeeAll={handleSeeAllClick}
                padding="20px 10px 20px 0px"
                marginTop="0px"
            />
            <Collection
                items={mediaPerPage ? mediaItems.slice(0, mediaPerPage) : mediaItems}
                type="grid"
                templateColumns={
                    "repeat(auto-fill, minmax(max(var(--grid-item--min-width), var(--grid-item--max-width)), 1fr))"
                }
                templateRows={"auto"}
                gap={"var(--grid-container-gap)"}
                autoFlow={"dense"}
                isPaginated={false}
                alignContent={"center"}
            >
                {(item: IMedia, index: number) => (
                    <MediaCard
                        mediaItem={item}
                        isPlalist={false}
                        cardClick={() => { }}
                        mediaRating={
                            mediaRating.find((_item) => _item.mediaId === item.mediaId)
                        }
                        enableRatingControls={enableRatingControls}
                        isSignedIn={isSignedIn}
                        hasEligiblePlan={
                            isSignedIn &&
                            (!!item.planDetails.length
                                ? !!activePlans.filter((memberPlan) =>
                                    item.planDetails?.some(
                                        (itemPlan) =>
                                            itemPlan?.id === memberPlan.id
                                    )
                                ).length ||
                                freeTrialPlanIds.includes(
                                    item.planDetails[0].id
                                ) ||
                                hasFullAccess
                                : true)
                        }
                        onWatchClick={onWatchClick}
                        onRatingSuccess={handleRatingSuccessLocal}
                        key={item.id}
                        sessionToken={sessionToken}
                        enableCompetitionMode={enableCompetitionMode}
                    />
                )}
            </Collection>
            <RatingToast show={showToast} onClose={() => setShowToast(false)} />

            {/* Modal with Lazy Loaded Cards */}
            <LayoutModal
                title={playlistTitle}
                show={isModalOpen}
                onHide={handleCloseModal}
                remainingMedia={remainingMedia}
                onCardClick={onCardClick}
                isSignedIn={isSignedIn}
                activePlans={activePlans}
                hasFullAccess={hasFullAccess}
                freeTrialPlanIds={freeTrialPlanIds}
                mediaRating={mediaRating}
                onWatchClick={onWatchClick}
                onRatingSuccess={onRatingSuccess}
                sessionToken={sessionToken}
            />

        </>
    );
};
